export const environment = {
  production: false,
  name: "Trail Fusion - Developer",

  baseUrl: "https://dev-admin-portal.trailfusion.net",
  verificationRedirectUrl: "https://dev-admin-portal.trailfusion.net",
  apiUrl:
    "https://us-central1-dev-admin-portal-2fc2e.cloudfunctions.net/api/admin",
  apiUrlNewCall:
    "https://us-central1-dev-admin-portal-2fc2e.cloudfunctions.net/api/",
  apiUrlCache:
    "https://us-central1-dev-admin-portal-2fc2e.cloudfunctions.net/api/cache",
  apiUrlMail:
    "https://us-central1-dev-admin-portal-2fc2e.cloudfunctions.net/api/mail",
  parentPortalUrl: "https://dev-parent-portal.trailfusion.net",
  firebase: {
    apiKey: "AIzaSyCIbL08sETyqU6693dwwzc5dY6i9ntyYd0",
    authDomain: "dev-admin-portal-2fc2e.firebaseapp.com",
    projectId: "dev-admin-portal-2fc2e",
    storageBucket: "dev-admin-portal-2fc2e.firebasestorage.app",
    messagingSenderId: "225030107551",
    appId: "1:225030107551:web:e7aaa299cdc1c54a918daa",
    measurementId: "G-J2ENS8HXJZ",
  },
  ipifyUrl: "https://api.ipify.org/?format=json",
  ipinfoUrl: "https://ipinfo.io/",
  ipinfoToken: "?token=abe7cb4c38b788",
  getClientIPAddressByIpify: "getClientIPAddressByIpify",
};
